module.exports = __webpack_public_path__ + "img/scene5-11.f395891b.png";